import * as React from "react";
const SvgChevronDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 11, height: 6, viewBox: "0 0 11 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.5 0.5L5.5 5.5L10.5 0.5H0.5Z", fill: "#667085" }));
export default SvgChevronDown;
